module.exports = __webpack_public_path__ + "img/wrong.5aa8d387.svg";